document.addEventListener('DOMContentLoaded', () => {
    const video = document.getElementById('hero-video');
    const toggleButton = document.getElementById('toggle-video');

    if (video) {
        toggleButton.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                toggleButton.setAttribute('aria-label', 'Pause Video');
            } else {
                video.pause();
                toggleButton.setAttribute('aria-label', 'Play Video');
            }
        });
    }
});

const scrollAnchor = document.getElementById('scrollToBottom');

if (scrollAnchor) {
    scrollAnchor.addEventListener('click', (e) => {
        e.preventDefault();

        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;

        const heroSection = document.querySelector('.hero');
        const bottomOfHero =
            heroSection.offsetTop + heroSection.offsetHeight - headerHeight;

        window.scrollTo({
            top: bottomOfHero,
            behavior: 'smooth'
        });
    });
}
